import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {BidService} from '../../services/bid.service';
import {StorageService} from '../../services/storage.service';
import {LoadingController} from '@ionic/angular';

@Component({
  selector: 'app-expediente',
  templateUrl: './expediente.page.html',
  styleUrls: ['./expediente.page.scss'],
})
export class ExpedientePage implements OnInit {

  expediente: any = {
    user: {},
    branchOffice: {}
  };
  type;
  privacyNotice = true;

  constructor(private router: Router, private bidApi: BidService,
              private storageService: StorageService,
              private loadingController: LoadingController) {
    this.getExpediente();
  }

  ngOnInit() {


  }

  nextPage() {
    if (this.type === 'register') {
      this.storageService.emptyStorage();
      this.router.navigateByUrl('/register-user');
    } else {
      this.router.navigateByUrl('/dashboard');

    }
  }

  getExpediente() {

    this.loadingController.getTop().then(hasLoading => {
      this.loadingController.create({
        spinner: 'circular',
        translucent: true
      }).then(loading => loading.present());
    });

    this.storageService.getStorage('personIdFound').then((p: any) => {

      this.storageService.getStorage('type').then((p1: any) => {

        console.log('******Type******');
        this.type = p1.value;
        console.log('******Type******');
        this.bidApi.expedeinte(p.value).subscribe((data: any) => {

          console.log(data);
          this.expediente = data;
          this.expediente.firstName = data.firstName + ' ' + data.middleName + ' ' + data.lastName;
          this.loadingController.dismiss();
        }, () => {
          this.loadingController.dismiss();
        });

      }, () => {
        this.loadingController.dismiss();
      });


    }, () => {
      this.loadingController.dismiss();
    });

  }

}
